export const navManager = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_PAGEID_CHANGE: 'updateNavComponents',
        LAYOUT_CHANGE_END: 'updateNavComponents',
        LAYOUT_SIDEBAR_CLOSE: 'updateNavComponents',
      },
    },
    updateNavComponents: {
      always: {
        target: 'idle',
        actions: [
          {
            type: 'batchLayoutOperations',
            data: [
              {
                type: 'setLayoutProperty',
                data: {
                  path:
                    'components.BottomNavigation.properties.currentPagePath',
                  value: '$event.mainLayoutPath',
                },
                meta: {
                  selectors: ['$action.data.value'],
                },
              },
              {
                type: 'setLayoutProperty',
                data: {
                  path: 'components.MainNavigation.properties.currentPagePath',
                  value: '$event.mainLayoutPath',
                },
                meta: {
                  selectors: ['$action.data.value'],
                },
              },
              {
                type: 'setLayoutProperty',
                data: {
                  path: 'components.MainNavigation.properties.basePath',
                  value: '$context.basePath',
                },
                meta: {
                  selectors: ['$action.data.value'],
                },
              },
              {
                type: 'setLayoutProperty',
                data: {
                  path: 'components.SubNavigation.properties.currentPagePath',
                  value: '$event.mainLayoutPath',
                },
                meta: {
                  selectors: ['$action.data.value'],
                },
              },
              {
                type: 'setLayoutProperty',
                data: {
                  path: 'components.SubNavigation.properties.basePath',
                  value: '$context.basePath',
                },
                meta: {
                  selectors: ['$action.data.value'],
                },
              },
              {
                type: 'setLayoutProperty',
                data: {
                  path: 'components.SubNavigation.properties.items',
                  value: '$context.subNavigationItems',
                },
                meta: {
                  selectors: ['$action.data.value'],
                },
              },
              {
                type: 'setLayoutProperty',
                data: {
                  path:
                    'components.MainNavigation.properties.numberOfAllSearchGames',
                  value: '$context.numberOfAllSearchGames',
                },
                meta: {
                  selectors: ['$action.data.value'],
                },
              },
            ],
          },
        ],
      },
    },
  },
};
